/** A provider callback is a wake-up hint, never canonical financial state. */
export function paymentReport(binding, next) {
    if (!binding ||
        [
            'ready',
            'unsupported',
            'quote_expired',
            'verification_pending',
            'widget_closed',
            'provider_failed',
        ].includes(next.phase))
        return null;
    return {
        ...binding,
        providerTransactionId: next.phase === 'reconciling' || next.phase === 'transaction_created'
            ? next.transactionId
            : null,
    };
}
export async function flushPaymentReport(client, pending, reporting, onFailure) {
    const report = pending.current;
    if (!report)
        return;
    reporting.current?.abort();
    const controller = new AbortController();
    reporting.current = controller;
    try {
        await client.reportPaymentEvent(report.operationId, report.attemptId, report.providerTransactionId, controller.signal);
        if (!controller.signal.aborted && pending.current === report)
            pending.current = null;
    }
    catch {
        // Keep uncertain hints for retry; never reissue frame execution permission.
        if (!controller.signal.aborted)
            onFailure();
    }
}
